import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from '../../lightningdb/ConditionSerialization.mjs';
import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.i3k_1.f2();
}
function DumpType$Companion$_anonymous__83ewqn() {
  return createSimpleEnumSerializer('com.lightningkite.lightningserver.db.DumpType', values());
}
var DumpType_CSV_instance;
var DumpType_JSON_LINES_instance;
function values() {
  return [DumpType_CSV_getInstance(), DumpType_JSON_LINES_getInstance()];
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.i3k_1 = lazy(tmp_0, DumpType$Companion$_anonymous__83ewqn);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  DumpType_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DumpType_entriesInitialized;
function DumpType_initEntries() {
  if (DumpType_entriesInitialized)
    return Unit_instance;
  DumpType_entriesInitialized = true;
  DumpType_CSV_instance = DumpType().o4l('CSV', 0);
  DumpType_JSON_LINES_instance = DumpType().o4l('JSON_LINES', 1);
  Companion_getInstance();
}
var DumpTypeClass;
function DumpType() {
  if (DumpTypeClass === VOID) {
    class $ extends Enum() {
      static o4l(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'DumpType', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    DumpTypeClass = $;
  }
  return DumpTypeClass;
}
function DumpRequest$Companion$$childSerializers$_anonymous__gfme7j() {
  return Companion_getInstance().k2a();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j3k_1 = [null, lazy(tmp_0, DumpRequest$Companion$$childSerializers$_anonymous__gfme7j), null];
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.db.DumpRequest', null, 3);
        tmp0_serialDesc.a1b('condition', false);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('email', true);
        this.k3k_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer().r4l(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static s4l() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.db.DumpRequest', $this, 3);
        tmp0_serialDesc.a1b('condition', false);
        tmp0_serialDesc.a1b('type', false);
        tmp0_serialDesc.a1b('email', true);
        $this.p4l_1 = tmp0_serialDesc;
        return $this;
      }
      t4l(encoder, value) {
        var tmp0_desc = this.p4l_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().j3k_1;
        tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.q4l_1), value.u4l_1);
        tmp1_output.c15(tmp0_desc, 1, tmp2_cached[1].f2(), value.v4l_1);
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.w4l_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, StringSerializer_getInstance(), value.w4l_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.t4l(encoder, value instanceof DumpRequest() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.p4l_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.l13(tmp0_desc);
        var tmp8_cached = Companion_getInstance_0().j3k_1;
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.q4l_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.q4l_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.x13(tmp0_desc, 1, tmp8_cached[1].f2(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.z13(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return DumpRequest().x4l(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.p4l_1;
      }
      r1b() {
        var tmp0_cached = Companion_getInstance_0().j3k_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.q4l_1), tmp0_cached[1].f2(), get_nullable(StringSerializer_getInstance())];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.q4l_1];
      }
      static r4l(typeSerial0) {
        var $this = this.s4l();
        $this.q4l_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var DumpRequestClass;
function DumpRequest() {
  if (DumpRequestClass === VOID) {
    class $ {
      toString() {
        return 'DumpRequest(condition=' + toString(this.u4l_1) + ', type=' + this.v4l_1.toString() + ', email=' + this.w4l_1 + ')';
      }
      hashCode() {
        var result = this.u4l_1.hashCode();
        result = imul(result, 31) + this.v4l_1.hashCode() | 0;
        result = imul(result, 31) + (this.w4l_1 == null ? 0 : getStringHashCode(this.w4l_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DumpRequest()))
          return false;
        if (!this.u4l_1.equals(other.u4l_1))
          return false;
        if (!this.v4l_1.equals(other.v4l_1))
          return false;
        if (!(this.w4l_1 == other.w4l_1))
          return false;
        return true;
      }
      static x4l(seen0, condition, type, email, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_0().k3k_1);
        }
        var $this = createThis(this);
        $this.u4l_1 = condition;
        $this.v4l_1 = type;
        if (0 === (seen0 & 4))
          $this.w4l_1 = null;
        else
          $this.w4l_1 = email;
        return $this;
      }
    }
    initMetadataForClass($, 'DumpRequest', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    DumpRequestClass = $;
  }
  return DumpRequestClass;
}
function DumpType_CSV_getInstance() {
  DumpType_initEntries();
  return DumpType_CSV_instance;
}
function DumpType_JSON_LINES_getInstance() {
  DumpType_initEntries();
  return DumpType_JSON_LINES_instance;
}
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance11v66jrt2are4,
  Companion_getInstance as Companion_getInstance31693c80p58in,
};
//endregion

//# sourceMappingURL=DumpRequest.mjs.map
